import { api } from './client';
import type { CreateTagRequest, TagDto } from './types';

export function listTags(workspaceId: string): Promise<TagDto[]> {
  return api<TagDto[]>(`/workspaces/${workspaceId}/tags`);
}

export function createTag(workspaceId: string, body: CreateTagRequest): Promise<TagDto> {
  return api<TagDto>(`/workspaces/${workspaceId}/tags`, { method: 'POST', body });
}

export function updateTag(tagId: string, body: { name?: string; color?: string }): Promise<TagDto> {
  return api<TagDto>(`/tags/${tagId}`, { method: 'PATCH', body });
}

export function deleteTag(tagId: string): Promise<void> {
  return api<void>(`/tags/${tagId}`, { method: 'DELETE' });
}
